import { Domain } from '@engagement/core/store/domain/domain.model';

export const getDomainUuid = (state: Domain) => state.domainUuid;
